import type { Control } from 'react-hook-form';
import { Controller } from 'src/components/form/field-controller/Controller';
import type { Content } from 'src/components/help-panel/useHelpStore';
import type { ThirdPartyOption } from 'src/hooks/queries/third-party/useGetThirdPartyOptions';
import type { IssueAssessmentFields } from 'src/pages/issues/update/forms/issue-assessment-form/issueAssessmentSchema';

import { ResponsibleThirdPartyAutosuggestView } from './ResponsibleThirdPartyAutosuggestView';
import { useResponsibleThirdPartyAutosuggest } from './useResponsibleThirdPartyAutosuggest';

export interface ResponsibleThirdPartyAutosuggestProps {
  control: Control<IssueAssessmentFields>;
  description?: Content;
  disabled?: boolean;
  isLoading: boolean;
  label: string;
  name: 'ThirdPartyResponsible';
  placeholder?: string;
  testId?: string;
  thirdPartyOptions: readonly ThirdPartyOption[];
}

export const ResponsibleThirdPartyAutosuggest = ({
  control,
  description,
  disabled,
  isLoading,
  label,
  name,
  placeholder,
  testId,
  thirdPartyOptions,
}: ResponsibleThirdPartyAutosuggestProps) => {
  const { props } = useResponsibleThirdPartyAutosuggest({
    control,
    disabled,
    isLoading,
    name,
    thirdPartyOptions,
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ResponsibleThirdPartyAutosuggestView
          {...props}
          field={field}
          guidance={description}
          label={label}
          placeholder={placeholder}
          testId={testId}
        />
      )}
    />
  );
};
